export default "__VITE_ASSET__Sr$2TvAn__"